<template>
  <no-auth v-if="!hasAuthorize.list"></no-auth>
  <div :class="{ 'o-card': !tab }" v-else>
    <Table
      no-card
      :title="$t(`${name}.mainTitle`)"
      :description="$t(`${name}.description`)"
      i18n
      :loading="loading"
      :status="$status.series"
      :items="items"
      checkable
      :checkValue="checkedList"
      @change:sort="SET_CHANGE_SORT"
      @change:checkedList="checkedList = $event"
      @change:selectAllWithoutPage="SET_CHECKED_ALL"
      :headers="headers"
      :page="page"
      :count="count"
      :pages="pages"
      :searchValue="search"
      @change:search="setSearch"
      @change:page="setChangedPage"
      :searchPlaceholder="$t(`${name}.searchPlaceholder`)"
    >
      <template #filter>
        <div class="row u-justify-content-flex-end">
          <div class="es-xs-12 es-sm-6 es-md-4 es-lg-3">
            <general-static-search
              :items="EhouseDoubleCalculatingTypeList"
              no-label
              clearable
              v-model="filter.type"
              :label="$t('ehouseDoubleCalculating.type')"
              optionField="label"
            ></general-static-search>
          </div>
        </div>
      </template>
      <template #new-button>
        <div class="u-display-flex u-width-100% u-justify-content-flex-end">
          <ExcelExport
            :fileName="`${name}-export-${date()}`"
            :fields="exportFields"
            :data="checkedList.length > 0 ? checkedList : items"
          >
            <template #button="{ showExcell }">
              <Button
                @click="showExcell()"
                variant="light-success"
                class="u-margin-right-xsmall"
              >
                <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
              </Button>
            </template>
          </ExcelExport>
          <router-link :to="{ name: `ehouse-double-calculating` }">
            <Button variant="light-primary"> + {{ $t(`${name}.add`) }} </Button>
          </router-link>
        </div>
      </template>
      <template #title="{ item }">
        <div class="u-cursor-pointer">
          <router-link
            :to="{
              name: `ehouse-double-calculating-detail`,
              params: { id: item.id },
            }"
          >
            <div class="u-color-primary"># {{ item.title }}</div>
          </router-link>
        </div>
      </template>
      <template #info="{ item }">
        <i class="icofont-user"></i> {{ item.user.fullname }}
        <i class="icofont-calendar"></i> {{ date(item.createdDate) }}

        <chip
          class="u-margin-0"
          :variant="item.isActive ? 'success' : 'danger'"
        >
          {{ item.isActive ? $tc("common.active") : $tc("common.passive") }}
        </chip>
        <Button
          @click="REMOVE_TO(item)"
          variant="light-danger"
          class="u-margin-0 u-float-right"
        >
          <i class="icofont-trash"></i>
        </Button>
      </template>
      <template #updatedDate="{ item }">
        <div class="u-color-primary">
          <i class="icofont-calendar"></i> {{ date(item.updatedDate) }}
        </div>
      </template>
      <template #type="{ item }">
        <div class="u-color-primary">
          {{ item.type }}
        </div>
      </template>
    </Table>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import DateHelper from "@/helpers/date";
import { mapGetters } from "vuex";
import Button from "../../Base/Button.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import ExcelExport from "../../Base/ExcelExport.vue";
import Requests from "@/services/Requests";
import mainProjectExportFields from "./export";
import Chip from "../../Base/Chip.vue";
import authorize from "./authorize";
import GeneralStaticSearch from "@/components/Searches/GeneralStaticSearch.vue";
import { EhouseDoubleCalculatingTypeList } from "@/enums/Calculatings/EdoubleCalculatingTypes";
export default {
  components: {
    RemoveModal,
    Table,
    Button,
    ExcelExport,
    Chip,
    GeneralStaticSearch,
  },
  mixins: [authorize, mainProjectExportFields],
  props: {
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noFilter: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      EhouseDoubleCalculatingTypeList,
      name: "ehouseDoubleCalculating",
      checkedList: [],
      showLockedModal: false,
      showRemoveModal: false,
      newMainProject: false,
      filter: {
        type: null,
      },
      sort: {},
      page: 1,
      search: "",
      items: [],
      loading: true,
      count: 0,
      headers: [
        {
          col: 10,
          sm: 4,
          md: 4,
          lg: 4,
          title: "ehouseCalculating.title",
          value: "title",
        },
        {
          col: 4,
          sm: 3,
          md: 3,
          lg: 3,
          title: "ehouseDoubleCalculating.type",
          value: "type",
        },
        {
          col: 8,
          sm: 4,
          md: 4,
          lg: 4,
          title: "",
          value: "info",
        },
      ],
      removeModal: { status: false, item: {} },
      lockedModal: { status: false, item: {} },
      showDetailModal: { status: false, adminDetailStatus: false, item: null },
    };
  },
  computed: {
    ...mapGetters({
      getActiveUser: "getActiveUser",
    }),
    pages() {
      return Math.ceil(this.count / 80);
    },
    exportFields() {
      if (this.items.length === 0) return {};
      return this.getExcelFields();
    },
  },
  watch: {
    filter: {
      handler() {
        this.setFilter();
      },
      deep: true,
    },
  },
  methods: {
    setFilter() {
      this.getItemsOfPage();
      this.page = 1;
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: 1,
          type: this.filter.type?.value || "",
        },
      });
    },

    async SET_CHECKED_ALL(data) {
      if (data) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: true,
          status: true,
        });
        const response = await Requests.HeatGain.GetHeatGainDoubleRooms({
          query: { page: 1, limit: this.count, search: this.search },
        });
        this.$status.series = response.message;
        if (response.message === "OK") {
          console.log(response.data);

          this.checkedList = [...response.data.items];
        }
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
      }
    },
    showDetail(item) {
      this.showDetailModal = {
        status: true,
        adminDetailStatus: false,
        item: item,
      };
    },
    showAdminDetail(item) {
      this.showDetailModal = {
        status: false,
        adminDetailStatus: true,
        item: item,
      };
    },
    date(value = new Date()) {
      const date = new DateHelper(this.$i18n.locale);
      return date.format(value);
    },
    SET_LOCKED_DESCRIPTION() {
      return this.lockedModal.item.isLocked ? "unlocked" : "locked";
    },
    REMOVE_TO(item) {
      this.removeModal = {
        status: true,
        item: item,
      };
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await Requests.HeatGain.DeleteHeatGainDoubleRoom({
        params: { id: this.removeModal.item.id },
      });
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`common.removeSuccess`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`common.removeError`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    setQuery() {
      const page = Number(this.$route.query.page);
      const search = this.$route.query.search;
      const type = this.$route.query.type;
      if (!isNaN(page)) this.page = page;
      if (search) this.search = search;
      if (type) {
        this.filter.type =
          EhouseDoubleCalculatingTypeList.find((item) => item.value === type) ||
          null;
      }
      if (!this.filter.type) this.getItemsOfPage();
    },
    async getItemsOfPage() {
      this.loading = true;
      this.removeModal = { status: false, item: {} };
      this.lockedModal = { status: false, item: {} };
      const response = await Requests.HeatGain.GetHeatGainDoubleRooms({
        query: {
          limit: 10,
          page: this.page,
          search: this.search,
          type: this.filter.type?.value || "",
          ...this.query,
        },
      });
      this.$status.ehouseCalculating = response.message;
      if (response.message === "OK") {
        this.items = response.data.items;
        this.count = response.data.count;
      }
      this.loading = false;
    },
    setSearch(search) {
      this.search = search;
      this.page = 1;
      this.$router.replace({
        query: { ...this.$route.query, search: this.search, page: 1 },
      });
      this.getItemsOfPage();
    },
    setChangedPage(page) {
      this.$router.replace({
        query: { ...this.$route.query, page: page },
      });
      this.page = page;
      this.getItemsOfPage();
    },
  },
  mounted() {
    this.setQuery();
  },
};
</script>

<style></style>
